/**
 * Instantiate an object to use with users service.  The userManagement singleton
 * was created first, but only worked for the environment the user is on.
 * This is only intended to be used for CaseCopyToolContainer.js
 */
import { create } from 'apisauce';

const authResultKey = 'vrpatients::auth::result';
const authResult = JSON.parse(localStorage.getItem(authResultKey));

function createUsersService(baseURL, token) {
  return create({
    baseURL,
    headers: {
      Authorization: authResult ? `Bearer ${authResult.idToken}` : undefined,
    },
 });
}

export default createUsersService;
